import { performRequest } from "../performRequest"



export const getEmployeesApi = (params) => {
    return performRequest("get", "api/ess/user/",params)
}

export const getEmployeeDetailApi = (id, params) => {
    return performRequest("get", `api/ess/user/${id}/`,params)
}

export const getLeavesApi = (params) => {
    return performRequest("get", `api/ess/leave/`,params)
}

export const getAssetsApi = (params) => {
    return performRequest("get", `api/ess/asset/`,params)
}

export const getEmployeeSalaryDetailApi = (id, params) => {
    return performRequest("get", `api/ess/salary/user/${id}/`,params)
}


export const getEmployeePayrollApi = (params) => {
    return performRequest("get", `api/ess/salary-slip/`,params)
}


export const changeEmployeeDetail = (id, params) => {
    return performRequest("patch", `/api/ess/user/${id}/`,params)
}




export const getAddressApi = (params) => {
    return performRequest("get", `api/ess/user/address/`,params)
}


export const createAddressApi = (params) => {

    return performRequest("post", `api/ess/user/address/`,params)
}

export const updateAddressApi = (id, params) => {
    
    return performRequest("put", `api/ess/user/address/${id}/`,params)
}


export const resendInvitation = (params) => {
    
    return performRequest("post", `/api/ess/invite-user/`,params)
}




export const deleteAddressApi = (id) => {
    
    return performRequest("delete", `api/ess/user/address/${id}/`)
}


export const exportEmployeeApi = (params) => {
    return performRequest("get", `api/ess/user/export/`,params, true, "blob")
}


export const getEmployeePayrollDownloadApi = (params) => {
    return performRequest("get", `api/ess/salary-slip-download/`,params, true, params.type == "export" ? "blob" : "json")
}
